<template>
  <div>
    <h6
      class="text-center text-gray"
      style="font-size: 12px;"
      v-html="getCaption('caption.copyright_bus_schedule')"
    ></h6>

    <div class="columns justify-content-center align-items-end">
      <div class="column col-xs-12 col-sm-10 col-10">
        <div @click="getScheduleData()" class="d-inline mt-2 c-hand">
          <span>{{ getCaption('caption.bus_station_refresh') }}</span>
          <button class="btn btn-sm btn--color-purple rounded ml-2">
            <i class="fas fa-sync-alt"></i>
          </button>
        </div>
      </div>
      <div class="column col-xs-12 col-sm-10 col-5 mt-2">
        <div class="form-horizontal">
          <div class="form-group">
            <div class="col-3 col-sm-12">
              <label class="form-label">{{ getCaption("caption.where_from") }}</label>
            </div>
            <div class="col-9 col-sm-12">
              <select v-model="departInput" @change="search" class="form-select focus-purple">
                <option :value="null" hidden disabled>{{ getCaption("caption.choose") }}</option>
                <option v-for="(location, index) in departList" :key="index">{{ location }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column col-xs-12 col-sm-10 col-5">
        <div class="form-horizontal">
          <div class="form-group">
            <div class="col-3 col-sm-12">
              <label class="form-label">{{ getCaption("caption.where_to") }}</label>
            </div>
            <div class="col-9 col-sm-12">
              <select v-model="arriveInput" @change="search" class="form-select focus-purple">
                <option :value="null" hidden disabled>{{ getCaption("caption.choose") }}</option>
                <option v-for="(location, index) in arriveList" :key="index">{{ location }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="column col-xs-12 col-sm-10 col-10 mt-2 pt-2">
        <div class="columns">
          <div class="column col-xs-12 col-sm-12 col-6 align-self-center">
            <div class="direction-row">
              <h4 class="depart-name">{{ departInput }}</h4>
              <div class="trip">
                <span class="trip_circle"></span>
                <span class="trip_line"></span>
                <span class="trip_icon">
                  <i class="fas fa-bus"></i>
                </span>
              </div>
              <h4 class="arrive-name">{{ arriveInput }}</h4>
            </div>
          </div>
          <div class="column col-xs-12 col-sm-12 col-6 align-self-center">
            <h4 class="my-2 py-2 text-center">{{ today }}</h4>
          </div>
        </div>

        <div v-if="isLoading" class="d-flex justify-content-center" style="margin: 3em 0;">
          <div class="loader"></div>
        </div>

        <ul v-if="searchResult" class="tab tab-block">
          <template v-for="(value, key, index) in searchResult">
            <li :class="[{'active': selectedTransportType==key}, 'tab-item']" :key="index">
              <a class="is-pointer size-3" @click="selectedTransportType = key">{{ key }}</a>
            </li>
          </template>
        </ul>

        <div class="columns">
          <div class="column col-xs-12 col-sm-12 col-12 col-mx-auto">
            <div v-if="searchResultEmpty" class="text-center">
              <span class="chip size-3 p-2">{{ getCaption("caption.empty_result") }}</span>
            </div>

            <table v-if="searchResult" class="table">
              <thead>
                <tr>
                  <th>{{ getCaption("caption.bus_depart_time") }}</th>
                  <th>{{ getCaption("caption.bus_number") }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(tripList, index) in searchResult[selectedTransportType]">
                  <tr :key="index">
                    <th
                      class="schedule-time"
                      :rowspan="tripList.length"
                    >{{ tripList[0].leave_time }}</th>
                    <td>{{ tripList[0].car_number }}</td>
                  </tr>
                  <template v-for="(trip, index) in tripList">
                    <tr v-if="index > 0" :key="trip.car_number">
                      <td>{{ trip.car_number }}</td>
                    </tr>
                  </template>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { transportationSchedule } from "@/constants/sidemenu.js";
import ScheduleService from "@/services/ScheduleService.js";

export default {
  data() {
    return {
      scheduleData: null,
      departInput: "УБ",
      arriveInput: "Да.Дархан",
      searchResult: null,
      isLoading: false,

      selectedTransportType: null
    };
  },

  computed: {
    departList() {
      if (this.scheduleData) {
        let arr = [];
        this.scheduleData.forEach(item => {
          let directionStr = item.direction_name;
          if (directionStr.includes(" - ")) {
            let substr = directionStr.substr(0, directionStr.indexOf(" - "));
            if (!arr.includes(substr)) {
              arr.push(substr);
            }
          }
        });
        arr.sort();
        return arr;
      } else {
        return null;
      }
    },

    arriveList() {
      if (this.scheduleData) {
        let arr = [];
        this.scheduleData.forEach(item => {
          let directionStr = item.direction_name;
          if (directionStr.includes(" - ")) {
            let substr = directionStr.substr(directionStr.indexOf(" - ") + 3);
            if (!arr.includes(substr)) {
              arr.push(substr);
            }
          }
        });
        arr.sort();
        return arr;
      } else {
        return null;
      }
    },

    today() {
      return moment().format("YYYY-MM-DD");
    },

    searchResultEmpty() {
      return this.searchResult != null && $.isEmptyObject(this.searchResult);
    }
  },

  mounted() {
    this.setSidemenu();
    this.getScheduleData();
  },

  methods: {
    setSidemenu() {
      let title = this.getCaption("caption.bus_schedule");

      this.$store.dispatch("setSidemenuData", {
        menu: transportationSchedule,
        parentType: "topmenu",
        parentId: "bus",
        title: title
      });
    },

    getScheduleData() {
      this.isLoading = true;
      this.searchResult = null;
      ScheduleService.getBusSchedule().then(response => {
        let arr = response.data;
        arr.forEach(item => {
          item.leave_date = this.parseDate(item.leave_date);
        });
        this.scheduleData = arr;
        this.isLoading = false;
        this.search();
      });
    },

    search() {
      if (this.departInput && this.arriveInput) {
        let directionStr = this.departInput + " - " + this.arriveInput;
        let arr = [];
        this.scheduleData.forEach(item => {
          if (item.direction_name == directionStr) {
            let leaveDate = new Date(item.leave_date);
            item.leave_time = moment(leaveDate).format("HH:mm");
            arr.push(item);
          }
        });

        let sortedArr = arr.sort(function(a, b) {
          var x = a["leave_date"];
          var y = b["leave_date"];
          return x < y ? -1 : x > y ? 1 : 0;
        });

        let groupedArr = sortedArr.reduce(function(r, a) {
          r[a.car_type_name] = r[a.car_type_name] || [];
          r[a.car_type_name].push(a);
          return r;
        }, Object.create(null));

        for (var key in groupedArr) {
          let nestedSort = groupedArr[key].reduce(function(r, a) {
            r[a.leave_time] = r[a.leave_time] || [];
            r[a.leave_time].push(a);
            return r;
          }, Object.create(null));

          groupedArr[key] = nestedSort;
        }

        this.selectedTransportType = Object.keys(groupedArr)[0];
        this.searchResult = groupedArr;
      }
    },

    parseDate(dateStr) {
      let second = dateStr.indexOf(":", dateStr.indexOf(":") + 1);
      let meridiem = dateStr.slice(-2);
      let formatStr = dateStr.substring(0, second) + " " + meridiem;
      let date = new Date(formatStr);
      let finalStr = moment(date).format("YYYY-MM-DD HH:mm");
      return finalStr;
    }
  }
};
</script>

<style lang="scss" scoped>
table {
  border: 1px solid #dadee4;
  margin-top: 20px;
}
thead th {
  background-color: #dadee4;
  text-align: center;
}
th.schedule-time {
  text-align: center;
  border-right: 1px solid #dadee4;
}

.tab .tab-item.active a,
.tab .tab-item a.active {
  border-bottom-color: #f78e21;
  color: #fff;
  background-color: #f78e21;

  -webkit-border-top-left-radius: 2px;
  -webkit-border-top-right-radius: 2px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}
.tab .tab-item a:hover {
  color: #f78e21;
  border-bottom-color: #f78e21;
}
.tab .tab-item.active a:hover,
.tab .tab-item a.active:hover {
  color: #fff;
}
</style>